import { ModalStatusType } from '../../../types/common';
import { Form, Formik } from 'formik';
import ModalComponent from '../../../components/modal/modal';
import ModalBodyComponent from '../../../components/modal/modalBodyComponent';
import ModalFooterComponent from '../../../components/modal/modalFooterComponent';
import _ from 'lodash';
import {
  useGetCompanyProfileDetails,
  useGetCurrentTenantInfo,
  useGetSandboxSwitchable,
  useGetSwitchSandboxList,
  useWealthlaneCustomerApi,
} from '../../../hooks';
import useGetCustomerUserDetails from '../../../hooks/get/useGetCustomerUserDetails';
import { PUSH_TO_PRODUCTION_VALIDATION } from '../../../utils/validations/validations';
import CustomTextArea from '../../../components/text-area/textArea';
import FormSelect from '../../../components/dropdown/formSelect';
import AuthService from '../../../services/authService';
import InitialValuesForm from '../../../constants/initialValues';
import usePostPushToProduction from '../../../hooks/post/usePostPushToProduction';
import useGetSwitchSandboxListForProduction from '../../../hooks/get/useGetSwitchSandboxListForProduction';
import useInstance from '../../../hooks/custom-hooks/useInstance';

interface PushToProductionModalType {
  isModalOpen: boolean;
  closeModal: () => void;
  modalStatus: ModalStatusType;
  modalLoading?: boolean;
  setModalStatus: (value: ModalStatusType) => void;
  rowData?: any;
  domId?: string;
  forceEnableSubmit?: boolean;
}

const PushToProductionModal = ({
  isModalOpen,
  closeModal,
  modalStatus,
  setModalStatus,
  rowData,
  domId,
  forceEnableSubmit,
}: PushToProductionModalType): JSX.Element => {
  const { handleRequest } = useWealthlaneCustomerApi();
  const tenantId = rowData?.tenantId;

  const { getTenantById, onKillInstance } = useInstance({ onClose() {} });
  const { data: switchableOptionType, isLoading: isSwitchableLoading } =
    useGetSwitchSandboxListForProduction(handleRequest);

  const { data: userDetails } = useGetCustomerUserDetails(handleRequest, true);

  const { data: companyDetails } = useGetCompanyProfileDetails(handleRequest, true);

  const { mutate: handleSubmit, isLoading } = usePostPushToProduction(handleRequest, () => {
    closeModal();
    const isInHomeCompany = userDetails?.companyId === companyDetails?.companyId;

    if (isInHomeCompany) {
      onKillInstance();
    } else {
      const cid = getTenantById()?.cid;
      window.location.href = `/#cid=${cid}`;
    }
  });
  const isInHomeCompany = userDetails?.companyId === companyDetails?.companyId;

  console.log(`
    isInHomeCompany : ${isInHomeCompany}
    
    `);
  return (
    <Formik
      enableReinitialize
      initialValues={Object.assign({}, InitialValuesForm.pushToProductionModal, {
        sandboxTenantId: tenantId,
      })}
      validationSchema={PUSH_TO_PRODUCTION_VALIDATION}
      onSubmit={handleSubmit}>
      {({
        touched,
        handleChange,
        errors,
        setFieldValue,
        setFieldTouched,
        values,
        initialValues,
      }) => {
        return (
          <ModalComponent
            show={isModalOpen}
            closeModal={closeModal}
            size='sm'
            title={`Sandbox Load To Main`}
            valueEdited={_.isEqual(values, initialValues)}
            id={domId}
            children={
              <Form id='pushToProductionForm'>
                <ModalBodyComponent id='modalBody'>
                  <FormSelect
                    type='text'
                    label='Instance'
                    name='sandboxTenantId'
                    id='sandboxTenantId'
                    viewName='sandboxTenantId'
                    onChange={(e: any) => {
                      // const name = switchableOptionType?.find((item) => item?.value === e)?.label;
                      setFieldValue('sandboxTenantId', e);
                    }}
                    errors={errors}
                    touched={touched}
                    options={switchableOptionType}
                    values={values}
                    setFieldValue={setFieldValue}
                    inputType={modalStatus}
                    disabled={modalStatus === 'View' || !_.isEmpty(tenantId)}
                    required
                    isLoading={isSwitchableLoading}
                  />

                  <CustomTextArea
                    label='Remarks'
                    rows='5'
                    name='remarks'
                    id='remarks'
                    onChange={handleChange}
                    errors={errors}
                    touched={touched}
                  />
                </ModalBodyComponent>
                <ModalFooterComponent
                  buttonTitle='Go'
                  modalStatus={modalStatus}
                  loading={isLoading}
                  onCloseModal={() => {
                    closeModal();
                  }}
                  onEditModal={() => {
                    setModalStatus('Edit');
                  }}
                  checkError={_.isEqual(values, initialValues) && !forceEnableSubmit}
                  id='modalFooter'
                />
              </Form>
            }
          />
        );
      }}
    </Formik>
  );
};

export default PushToProductionModal;
